/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CandidateCandidate,
    CandidateCandidateFromJSON,
    CandidateCandidateToJSON,
    CandidateCompany,
    CandidateCompanyFromJSON,
    CandidateCompanyToJSON,
    CandidateCountOfferPerState,
    CandidateCountOfferPerStateFromJSON,
    CandidateCountOfferPerStateToJSON,
    CandidateLetter,
    CandidateLetterFromJSON,
    CandidateLetterToJSON,
    CandidateLink,
    CandidateLinkFromJSON,
    CandidateLinkToJSON,
    CandidateOffer,
    CandidateOfferFromJSON,
    CandidateOfferToJSON,
    CandidateOfferFilters,
    CandidateOfferFiltersFromJSON,
    CandidateOfferFiltersToJSON,
    CandidateOfferItem,
    CandidateOfferItemFromJSON,
    CandidateOfferItemToJSON,
    CandidateOfferItemPaginated,
    CandidateOfferItemPaginatedFromJSON,
    CandidateOfferItemPaginatedToJSON,
    CandidatePublicOfferItem,
    CandidatePublicOfferItemFromJSON,
    CandidatePublicOfferItemToJSON,
    DefaultResponse,
    DefaultResponseFromJSON,
    DefaultResponseToJSON,
    InlineObject1,
    InlineObject1FromJSON,
    InlineObject1ToJSON,
    InlineResponse200,
    InlineResponse200FromJSON,
    InlineResponse200ToJSON,
    LoginResponse,
    LoginResponseFromJSON,
    LoginResponseToJSON,
    OffersCount,
    OffersCountFromJSON,
    OffersCountToJSON,
} from '../models';

export interface CandidateCompanyIdGetRequest {
    id: number;
}

export interface CandidateDocumentPostRequest {
    file?: Blob;
}

export interface CandidateExternalUrlIdGetRequest {
    id: number;
}

export interface CandidateLettersIdDeleteRequest {
    id: number;
}

export interface CandidateLettersPostRequest {
    candidateLetter?: CandidateLetter;
}

export interface CandidateLettersPutRequest {
    candidateLetter?: CandidateLetter;
}

export interface CandidateLinksPostRequest {
    candidateLink?: Array<CandidateLink>;
}

export interface CandidateOffersCountGetRequest {
    applied?: boolean;
    company?: number;
    modalities?: string;
    presences?: string;
    states?: string;
    academicPrograms?: string;
    status?: string;
    page?: number;
    limit?: number;
}

export interface CandidateOffersFiltersGetRequest {
    applied?: boolean;
    company?: number;
    modalities?: string;
    presences?: string;
    states?: string;
    academicPrograms?: string;
    status?: string;
    page?: number;
    limit?: number;
}

export interface CandidateOffersGetRequest {
    applied?: boolean;
    company?: number;
    modalities?: string;
    states?: string;
    academicPrograms?: string;
    status?: string;
}

export interface CandidateOffersIdApplyPostRequest {
    id: number;
    inlineObject1?: InlineObject1;
}

export interface CandidateOffersIdGetRequest {
    id: number;
}

export interface CandidateOffersPagedGetRequest {
    applied?: boolean;
    company?: number;
    modalities?: string;
    presences?: string;
    states?: string;
    academicPrograms?: string;
    status?: string;
    page?: number;
    limit?: number;
}

export interface CandidatePublicOffersGetRequest {
    company?: number;
    modalities?: string;
    states?: string;
    academicPrograms?: string;
    status?: string;
}

/**
 * 
 */
export class CandidateApi extends runtime.BaseAPI {

    /**
     * [P_A_24]
     */
    async candidateAcceptPrivacyPolicyPutRaw(): Promise<runtime.ApiResponse<DefaultResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/candidate/accept_privacy_policy`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DefaultResponseFromJSON(jsonValue));
    }

    /**
     * [P_A_24]
     */
    async candidateAcceptPrivacyPolicyPut(): Promise<DefaultResponse> {
        const response = await this.candidateAcceptPrivacyPolicyPutRaw();
        return await response.value();
    }

    /**
     * Vista del candidato des sus propios datos [P_A_22]
     */
    async candidateCandidateGetRaw(): Promise<runtime.ApiResponse<CandidateCandidate>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/candidate/candidate`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CandidateCandidateFromJSON(jsonValue));
    }

    /**
     * Vista del candidato des sus propios datos [P_A_22]
     */
    async candidateCandidateGet(): Promise<CandidateCandidate> {
        const response = await this.candidateCandidateGetRaw();
        return await response.value();
    }

    /**
     * Info de una empresa [P_A_31]
     */
    async candidateCompanyIdGetRaw(requestParameters: CandidateCompanyIdGetRequest): Promise<runtime.ApiResponse<CandidateCompany>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling candidateCompanyIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/candidate/company/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CandidateCompanyFromJSON(jsonValue));
    }

    /**
     * Info de una empresa [P_A_31]
     */
    async candidateCompanyIdGet(requestParameters: CandidateCompanyIdGetRequest): Promise<CandidateCompany> {
        const response = await this.candidateCompanyIdGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * Eliminación del fichero subido
     */
    async candidateDocumentDeleteRaw(): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/candidate/document`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Eliminación del fichero subido
     */
    async candidateDocumentDelete(): Promise<boolean> {
        const response = await this.candidateDocumentDeleteRaw();
        return await response.value();
    }

    /**
     * Download del fichero [P_A_22]. No se indica id porque es 1:1 con alumno
     */
    async candidateDocumentGetRaw(): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/candidate/document`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Download del fichero [P_A_22]. No se indica id porque es 1:1 con alumno
     */
    async candidateDocumentGet(): Promise<Blob> {
        const response = await this.candidateDocumentGetRaw();
        return await response.value();
    }

    /**
     * Upload del fichero [P_A_22]
     */
    async candidateDocumentPostRaw(requestParameters: CandidateDocumentPostRequest): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/candidate/document`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Upload del fichero [P_A_22]
     */
    async candidateDocumentPost(requestParameters: CandidateDocumentPostRequest): Promise<boolean> {
        const response = await this.candidateDocumentPostRaw(requestParameters);
        return await response.value();
    }

    /**
     * Marca el enlace como visitado y redirige a la url externa
     */
    async candidateExternalUrlIdGetRaw(requestParameters: CandidateExternalUrlIdGetRequest): Promise<runtime.ApiResponse<InlineResponse200>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling candidateExternalUrlIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/candidate/external_url/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => InlineResponse200FromJSON(jsonValue));
    }

    /**
     * Marca el enlace como visitado y redirige a la url externa
     */
    async candidateExternalUrlIdGet(requestParameters: CandidateExternalUrlIdGetRequest): Promise<InlineResponse200> {
        const response = await this.candidateExternalUrlIdGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * [P_A_24]
     */
    async candidateLettersGetRaw(): Promise<runtime.ApiResponse<Array<CandidateLetter>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/candidate/letters`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CandidateLetterFromJSON));
    }

    /**
     * [P_A_24]
     */
    async candidateLettersGet(): Promise<Array<CandidateLetter>> {
        const response = await this.candidateLettersGetRaw();
        return await response.value();
    }

    /**
     * [P_A_24]
     */
    async candidateLettersIdDeleteRaw(requestParameters: CandidateLettersIdDeleteRequest): Promise<runtime.ApiResponse<DefaultResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling candidateLettersIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/candidate/letters/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DefaultResponseFromJSON(jsonValue));
    }

    /**
     * [P_A_24]
     */
    async candidateLettersIdDelete(requestParameters: CandidateLettersIdDeleteRequest): Promise<DefaultResponse> {
        const response = await this.candidateLettersIdDeleteRaw(requestParameters);
        return await response.value();
    }

    /**
     * [P_A_24]
     */
    async candidateLettersPostRaw(requestParameters: CandidateLettersPostRequest): Promise<runtime.ApiResponse<DefaultResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/candidate/letters`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CandidateLetterToJSON(requestParameters.candidateLetter),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DefaultResponseFromJSON(jsonValue));
    }

    /**
     * [P_A_24]
     */
    async candidateLettersPost(requestParameters: CandidateLettersPostRequest): Promise<DefaultResponse> {
        const response = await this.candidateLettersPostRaw(requestParameters);
        return await response.value();
    }

    /**
     * [P_A_24]
     */
    async candidateLettersPutRaw(requestParameters: CandidateLettersPutRequest): Promise<runtime.ApiResponse<DefaultResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/candidate/letters`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CandidateLetterToJSON(requestParameters.candidateLetter),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DefaultResponseFromJSON(jsonValue));
    }

    /**
     * [P_A_24]
     */
    async candidateLettersPut(requestParameters: CandidateLettersPutRequest): Promise<DefaultResponse> {
        const response = await this.candidateLettersPutRaw(requestParameters);
        return await response.value();
    }

    /**
     * No hay GET, vienen en el candidate. No hay PUT, hacemos siempre post machacando todos los elementos. [P_A_23]
     */
    async candidateLinksPostRaw(requestParameters: CandidateLinksPostRequest): Promise<runtime.ApiResponse<DefaultResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/candidate/links`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.candidateLink.map(CandidateLinkToJSON),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DefaultResponseFromJSON(jsonValue));
    }

    /**
     * No hay GET, vienen en el candidate. No hay PUT, hacemos siempre post machacando todos los elementos. [P_A_23]
     */
    async candidateLinksPost(requestParameters: CandidateLinksPostRequest): Promise<DefaultResponse> {
        const response = await this.candidateLinksPostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async candidateOffersCountGetRaw(requestParameters: CandidateOffersCountGetRequest): Promise<runtime.ApiResponse<OffersCount>> {
        const queryParameters: any = {};

        if (requestParameters.applied !== undefined) {
            queryParameters['applied'] = requestParameters.applied;
        }

        if (requestParameters.company !== undefined) {
            queryParameters['company'] = requestParameters.company;
        }

        if (requestParameters.modalities !== undefined) {
            queryParameters['modalities'] = requestParameters.modalities;
        }

        if (requestParameters.presences !== undefined) {
            queryParameters['presences'] = requestParameters.presences;
        }

        if (requestParameters.states !== undefined) {
            queryParameters['states'] = requestParameters.states;
        }

        if (requestParameters.academicPrograms !== undefined) {
            queryParameters['academic_programs'] = requestParameters.academicPrograms;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/candidate/offers_count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OffersCountFromJSON(jsonValue));
    }

    /**
     */
    async candidateOffersCountGet(requestParameters: CandidateOffersCountGetRequest): Promise<OffersCount> {
        const response = await this.candidateOffersCountGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async candidateOffersFiltersGetRaw(requestParameters: CandidateOffersFiltersGetRequest): Promise<runtime.ApiResponse<CandidateOfferFilters>> {
        const queryParameters: any = {};

        if (requestParameters.applied !== undefined) {
            queryParameters['applied'] = requestParameters.applied;
        }

        if (requestParameters.company !== undefined) {
            queryParameters['company'] = requestParameters.company;
        }

        if (requestParameters.modalities !== undefined) {
            queryParameters['modalities'] = requestParameters.modalities;
        }

        if (requestParameters.presences !== undefined) {
            queryParameters['presences'] = requestParameters.presences;
        }

        if (requestParameters.states !== undefined) {
            queryParameters['states'] = requestParameters.states;
        }

        if (requestParameters.academicPrograms !== undefined) {
            queryParameters['academic_programs'] = requestParameters.academicPrograms;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/candidate/offers_filters`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CandidateOfferFiltersFromJSON(jsonValue));
    }

    /**
     */
    async candidateOffersFiltersGet(requestParameters: CandidateOffersFiltersGetRequest): Promise<CandidateOfferFilters> {
        const response = await this.candidateOffersFiltersGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async candidateOffersGetRaw(requestParameters: CandidateOffersGetRequest): Promise<runtime.ApiResponse<Array<CandidateOfferItem>>> {
        const queryParameters: any = {};

        if (requestParameters.applied !== undefined) {
            queryParameters['applied'] = requestParameters.applied;
        }

        if (requestParameters.company !== undefined) {
            queryParameters['company'] = requestParameters.company;
        }

        if (requestParameters.modalities !== undefined) {
            queryParameters['modalities'] = requestParameters.modalities;
        }

        if (requestParameters.states !== undefined) {
            queryParameters['states'] = requestParameters.states;
        }

        if (requestParameters.academicPrograms !== undefined) {
            queryParameters['academic_programs'] = requestParameters.academicPrograms;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/candidate/offers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CandidateOfferItemFromJSON));
    }

    /**
     */
    async candidateOffersGet(requestParameters: CandidateOffersGetRequest): Promise<Array<CandidateOfferItem>> {
        const response = await this.candidateOffersGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * Acto del alumno de inscribirse en una oferta [P_A_05]
     */
    async candidateOffersIdApplyPostRaw(requestParameters: CandidateOffersIdApplyPostRequest): Promise<runtime.ApiResponse<CandidateOffer>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling candidateOffersIdApplyPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/candidate/offers/{id}/apply`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InlineObject1ToJSON(requestParameters.inlineObject1),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CandidateOfferFromJSON(jsonValue));
    }

    /**
     * Acto del alumno de inscribirse en una oferta [P_A_05]
     */
    async candidateOffersIdApplyPost(requestParameters: CandidateOffersIdApplyPostRequest): Promise<CandidateOffer> {
        const response = await this.candidateOffersIdApplyPostRaw(requestParameters);
        return await response.value();
    }

    /**
     * [P_A_03] [P_A_12] [P_A_05]
     */
    async candidateOffersIdGetRaw(requestParameters: CandidateOffersIdGetRequest): Promise<runtime.ApiResponse<CandidateOffer>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling candidateOffersIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/candidate/offers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CandidateOfferFromJSON(jsonValue));
    }

    /**
     * [P_A_03] [P_A_12] [P_A_05]
     */
    async candidateOffersIdGet(requestParameters: CandidateOffersIdGetRequest): Promise<CandidateOffer> {
        const response = await this.candidateOffersIdGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async candidateOffersPagedGetRaw(requestParameters: CandidateOffersPagedGetRequest): Promise<runtime.ApiResponse<CandidateOfferItemPaginated>> {
        const queryParameters: any = {};

        if (requestParameters.applied !== undefined) {
            queryParameters['applied'] = requestParameters.applied;
        }

        if (requestParameters.company !== undefined) {
            queryParameters['company'] = requestParameters.company;
        }

        if (requestParameters.modalities !== undefined) {
            queryParameters['modalities'] = requestParameters.modalities;
        }

        if (requestParameters.presences !== undefined) {
            queryParameters['presences'] = requestParameters.presences;
        }

        if (requestParameters.states !== undefined) {
            queryParameters['states'] = requestParameters.states;
        }

        if (requestParameters.academicPrograms !== undefined) {
            queryParameters['academic_programs'] = requestParameters.academicPrograms;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/candidate/offers_paged`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CandidateOfferItemPaginatedFromJSON(jsonValue));
    }

    /**
     */
    async candidateOffersPagedGet(requestParameters: CandidateOffersPagedGetRequest): Promise<CandidateOfferItemPaginated> {
        const response = await this.candidateOffersPagedGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async candidateOffersPerStateGetRaw(): Promise<runtime.ApiResponse<Array<CandidateCountOfferPerState>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/candidate/offers_per_state`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CandidateCountOfferPerStateFromJSON));
    }

    /**
     */
    async candidateOffersPerStateGet(): Promise<Array<CandidateCountOfferPerState>> {
        const response = await this.candidateOffersPerStateGetRaw();
        return await response.value();
    }

    /**
     */
    async candidatePublicOffersGetRaw(requestParameters: CandidatePublicOffersGetRequest): Promise<runtime.ApiResponse<Array<CandidatePublicOfferItem>>> {
        const queryParameters: any = {};

        if (requestParameters.company !== undefined) {
            queryParameters['company'] = requestParameters.company;
        }

        if (requestParameters.modalities !== undefined) {
            queryParameters['modalities'] = requestParameters.modalities;
        }

        if (requestParameters.states !== undefined) {
            queryParameters['states'] = requestParameters.states;
        }

        if (requestParameters.academicPrograms !== undefined) {
            queryParameters['academic_programs'] = requestParameters.academicPrograms;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/candidate/public_offers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CandidatePublicOfferItemFromJSON));
    }

    /**
     */
    async candidatePublicOffersGet(requestParameters: CandidatePublicOffersGetRequest): Promise<Array<CandidatePublicOfferItem>> {
        const response = await this.candidatePublicOffersGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * comprueba login de CAS
     */
    async casLoginGetRaw(): Promise<runtime.ApiResponse<LoginResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/cas/login`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginResponseFromJSON(jsonValue));
    }

    /**
     * comprueba login de CAS
     */
    async casLoginGet(): Promise<LoginResponse> {
        const response = await this.casLoginGetRaw();
        return await response.value();
    }

}
